export const accessoryPartsKey = 'accessoryParts';
export const brakesPartsKey = 'brakesParts';
export const carbodyPartsKey = 'carbodyParts';
export const electricPartsKey = 'electricParts';
export const enginePartsKey = 'engineParts';
export const interiorPartsKey = 'interiorParts';
export const equipmentPartsKey = 'equipmentParts';
export const gasEquipmentPartsKey = 'gasEquipmentParts';
export const heatingPartsKey = 'heatingParts';
export const maintenancePartsKey = 'maintenanceParts';
export const namePartsKey = 'nameParts';
export const statePartsKey = 'stateParts';
export const suspensionPartsKey = 'suspensionParts';
export const transmissionPartsKey = 'transmissionParts';
export const typePartsKey = 'typeParts';
export const tyreSeasonPartsKey = 'tyreSeasonParts';
export const wheelsBoltsPartsKey = 'wheelsBoltsParts';
export const wheelsPartsKey = 'wheelsParts';
export const wheelsRadiusPartsKey = 'wheelsRadiusParts';
export const wheelsWidthPartsKey = 'wheelsWidthParts';
export const clearPartsKey = 'clearParts';
